<!-- =========================================================================================
    File Name: VxList.vue
    Description: list Component
    Component Name: VxList
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <div class="vx-row no-gutter justify-center items-center mb-8">
      <img
        src="@/assets/images/logo/logo-sbt.png"
        alt="Logo SBT"
        class="logo"
      />
    </div>
    <h3 class="text-center mb-8">
      INSTRUMENTO PARTICULAR DE AUTORIZAÇÃO DE USO DE IMAGEM, CESSÃO DE DIREITOS
      PATRIMONIAIS E OUTRAS AVENÇAS
    </h3>
    <p class="text-justify mt-5">
      1. Pelo presente instrumento, e na melhor forma de direito, o(a) maior
      abaixo qualificado, declara expressamente que aceita participar de
      gravações de cenas da obra audiovisual <b>“PROGRAMA SILVIO SANTOS”</b>,
      doravante denominada OBRA, produzida pela TVSBT CANAL 4 DE SÃO PAULO S/A,
      sediada na cidade de Osasco, Estado de São Paulo, na Av. das Comunicações,
      n° 04, Bairro Vila Jaraguá, inscrita no CNPJ (MF) 45.039.237/0001-14.
      <b>(“PRODUTORA”)</b>
    </p>
    <div class="mt-3">
      <b>Dados do participante</b>
      <p>
        <b>Nome:</b> {{ this.data.name }} {{ this.data.surname }},
        <b>nascimento:</b> {{ this.data.birthdate | formatDate }},
        <b>telefone:</b> {{ this.data.mobile | formatMobile }}, <b>RG:</b>
        {{ this.data.rg | formatRG }}, <b>CPF:</b>
        {{ this.data.cpf | formatCPF }}, <b>profissão:</b>
        {{ this.data.occupation }}, <b>estado civil:</b>
        {{ this.data.maritalStatus }}, <b>email:</b>
        {{ this.data.email }}
      </p>
    </div>
    <div class="mt-3">
      <b>Endereço</b>
      <p>
        <b>Rua:</b> {{ this.data.street }}, <b>número:</b>
        {{ this.data.number }}, <b>bairro:</b> {{ this.data.neighborhood }},
        <b>cidade:</b>
        {{ this.data.city }}, <b>estado:</b> {{ this.data.state }}, <b>cep:</b>
        {{ this.data.zipCode }}
      </p>
    </div>
    <p class="text-justify mt-5">
      2. Relativamente à sua participação na Obra e na forma estabelecida no
      artigo 49, incisos I e II da Lei 9.610/98, o(a)
      <b>“PARTICIPANTE”</b> acima qualificado expressamente cede e transfere de
      forma irrevogável e irretratável à <b>PRODUTORA</b> a totalidade de seus
      direitos de natureza patrimonial decorrentes de sua participação na OBRA,
      a título universal e de forma definitiva, para uso e comercialização em
      todos os territórios do Brasil e do Exterior e em todas as mídias,
      formatos e formas de exploração possíveis, pelo prazo máximo de proteção
      determinado pela Lei Brasileira (setenta anos) e, ainda, pelo prazo das
      leis aplicáveis à espécie, em cada território considerado.
    </p>
    <div class="mt-5">
      3. Os direitos de exibição ou reexibição da OBRA, na forma mencionada
      neste contrato, bem como a venda e/ou locação dos mesmos, vigorarão em
      todos os territórios, durante todo o período de proteção garantido pelas
      leis aplicáveis em cada território considerado, ou seja, a qualquer tempo,
      pois os mesmos são de propriedade exclusiva da TVSBT.
    </div>
    <p class="text-justify mt-5">
      4. Desta forma, na condição de detentora da totalidade dos direitos
      patrimoniais sobre direitos autorais, de imagem e conexos incidentes sobre
      a participação do <b>PARTICIPANTE</b> na(s) Obra(s) e/ou nos Materiais
      da(s) Obra(s), a <b>PRODUTORA</b> poderá livremente dispor da(s) Obra(s),
      Materiais da(s) Obra(s), obras derivadas e subprodutos, bem como, de todo
      material bruto decorrente, de seus extratos, trechos ou partes, sem limite
      de quantidade, local e tempo de utilização, para qualquer finalidade,
      inclusive publicitária, promovendo a sua exploração econômica por qualquer
      meio forma, tecnologia ou processo, incluindo-se a execução pública
      através de qualquer sistema de transmissão ou por qualquer outro meio de
      transporte de sinal atualmente existente ou que no futuro venha a ser
      criado, e, ainda, por quaisquer empresas de comunicação do país e no
      exterior, pelas emissoras da
      <b>PRODUTORA TVSBT – CANAL 4 DE SÃO PAULO S/A</b> (ou empresas
      pertencentes ao seu grupo econômico), suas afiliadas, por emissoras
      componentes de outras redes e emissoras independentes, bem como demais
      veículos de comunicação, e ainda, o armazenamento em computador para
      distribuição digital em qualquer sistema de rede de computadores, bem
      como, todas demais modalidades referidas expressamente nos incisos do
      artigo 29 e 90 da Lei 9.610/98. Por conseguinte, a <b>PRODUTORA</b>, seus
      parceiros, cessionários, licenciados e/ou terceiros autorizados, poderão
      proceder à: (i) fixação da participação do <b>PARTICIPANTE</b> na Obra, em
      qualquer tipo de suporte material hoje existente, analógico ou digital em
      qualquer tipo de suporte tangível ou intangível, impresso, magnético,
      eletromagnético, ótico, eletrônico, digital, multimídia e, também, através
      da representação digital de sons e imagens, tais como películas
      cinematográficas de qualquer bitola, CD, CD ROM, CD-I (“compact disc”
      interativo), DAT (“digital áudio tape”), DVD (“digital vídeo disc”),
      Blu-Ray e suportes de discos de leitura digital em geral; (ii) exibição e
      reexibição da Obra, no Brasil e/ou no exterior, de forma simultânea ou
      não, pela <b>PRODUTORA</b>, e/ou por terceiros por elas indicados: (a) em
      televisão llinear de qualquer espécie (televisão aberta ou televisão por
      assinatura, através de qualquer das suas modalidades), exibições estas que
      poderão ser realizadas via transmissão ou retransmissão por radiodifusão,
      UHF, VHF, cabo, MMDS, IPTV, satélite, rede mundial de internet, DTT, LPTV,
      CATV, SMATV, MMDS, TVRO pagos, micro-ondas, cabo sem fio, online (por
      exemplo, downloads, streams), sem fio (wireless), via file server DSL,
      ADSL, sistemas de telefonia, UHF codificado, superestações e sistemas de
      televisão em circuito fechado, independentemente da modalidade de
      comercialização empregada, incluindo “pay tv", “pay per view”; (b) em
      exploração não linear, em todos os tipos de vídeo sob demanda (“VOD”) tais
      como VOD gratuito (FVOD), VOD suportado por publicidade (AVOD), VOD por
      assinatura (SVOD), VOD transacional (TVOD) , “near video on demand”,
      Download to Own (Donwload para Aquisição – DTO), Download to Rend
      (Download para Locação – DTL) independentemente das características e
      atributos do sistema de distribuição, abrangendo plataformas analógicas ou
      digitais, com atributos de interatividade, ou não, redes sociais, Youtube,
      aplicativos, OTT – Over The Top, rede mundial de internet ou por qualquer
      outro meio de transporte de sinal hoje existente, e independentemente do
      sistema e tecnologias de transmissão e do equipamento receptor (handhelds,
      smartphones, computadores, televisões conectadas, aparelhos de videogame
      entre outros); e (c) em qualquer outro meio de comunicação que permita a
      exibição, ainda que parcial, dos sons e/ou imagens da Obra, gratuita ou
      onerosamente; (iii) exibição, reexibição e disponibilização da Obra no
      Brasil e/ou no exterior, sem limitação de tempo ou número de vezes: (a)
      através de projeção em tela, em qualquer tipo de local de frequência
      coletiva, tais como salas de exposições, museus, feiras, eventos públicos
      ou particulares (como festivais online e off-line), entre outros; (b) em
      circuito fechado tais como aeronaves e embarcações; (c) em circuito
      cinematográfico, (inclusive institucional), holográfica e projeções, em
      locais de visitação coletiva, com ou sem ingresso pago; (d) através da
      Internet; (e) da inclusão de banco de dados ou do armazenamento em memória
      de computador para fins de entrega a terceiros mediante qualquer processo
      existente; (f) de rádio; e (g) em locais públicos, com ou sem ingresso
      pago, pela <b>PRODUTORA</b>, e/ou por terceiros que venham dela a adquirir
      tais direitos; (iv) comercialização ou disponibilização, para o público em
      geral, no Brasil e/ou no exterior, direta ou indiretamente de reproduções
      da Obra, integral ou em partes, através de suportes materiais, para a
      finalidade de vídeo doméstico (“home vídeo”) e venda direta ao consumidor,
      incluindo, mas sem restrição, os suportes de CD, CD ROM, CD-I, DAT, DVD,
      dispositivos de memória, dispositivos portáteis e suportes de leitura
      digital em geral; (a) de fixações em qualquer tipo de suporte material
      existente, e (b) de qualquer outro meio de comunicação que permita a
      exibição, ainda que parcial, dos sons e/ou imagens da Obra; distribuição
      através de Internet ou telefonia, fixa ou móvel; (v) utilização, pela
      <b>PRODUTORA</b>, seus parceiros, cessionários, licenciados e/ou terceiros
      autorizados, a qualquer tempo, no Brasil e/ou no exterior, em número
      ilimitado de vezes, de extratos da Obra, seus trechos ou partes, edições,
      adaptações, narrações, sonorizações, traduções, legendas, ou dublagens em
      quaisquer idiomas, bem como de reproduções da voz e/ou da imagem do
      <b>PARTICIPANTE</b>, inclusive fotográficas, na Obra, para (a) inserção em
      outras obras audiovisuais, Programas ou projetos de criação intelectual,
      (b) fins institucionais, (c) produção de matéria promocional e quaisquer
      materiais de divulgação em qualquer tipo de mídia, inclusive impressa,
      seja para fins de divulgação da Obra (inclusive somente áudio e imagens
      estáticas) por quaisquer modalidades e para quaisquer suportes
      (interativos ou não) ou para a divulgação de qualquer produto ligado à
      mesma ou seus patrocinadores, tais como, mas não limitados a, cartazes,
      outdoors, filmes para a divulgação da Obra, anúncios a serem reproduzidos
      em veículos de comunicação de mídia impressa, virtual disponível em
      websites e redes sociais (como Facebook, Instagram, Twitter e Snapchat),
      ou em qualquer tipo de mídia, assim como capas de CD, DVD, e de outros
      suportes materiais que sejam objeto de comercialização para vídeo
      doméstico (“home vídeo”), entre outros, (d) produção do “making of” da
      Obra ou obras derivadas, bem como outros fins de divulgação ou promoção
      que contribuam para a difusão Obra; (vi) adaptação para promover ações de
      merchandising ou veiculação de propaganda; (vii) disponibilização da Obra
      e dos Materiais e adaptação para fins de produção de outros programas ou
      projetos de criação intelectual tais como “fotonovelas, documentários,
      peças publicitárias, produção de calendários, livros, jornais e revistas,
      mala-direta, marketing viral, impressos ou on-line, quaisquer outros
      produtos impressos, games, jogos interativos, artigos de escritório,
      vestuários, calçados, alimentos, dentre outros;
    </p>
    <p class="text-justify mt-5">
      5. O <b>PARTICIPANTE</b> autoriza a <b>PRODUTORA</b> a licenciar produtos
      e/ou serviços ligados a imagem e/ou semelhança exclusivamente com relação
      a sua participação na Obra. A <b>PRODUTORA</b> inclusive poderá utilizar a
      imagem da Obra e da participação do (a) declarante no mesmo, bem como, o
      som de voz desse último para divulgação do produto licenciado em quaisquer
      campanhas publicitárias e anúncios em quaisquer mídias.
    </p>
    <p class="text-justify mt-5">
      6. O (a) <b>PARTICIPANTE</b> autoriza a <b>PRODUTORA</b> proceder, sempre
      que necessário, a dublagem de sua voz em qualquer idioma por terceiros por
      elas selecionados.
    </p>
    <p class="text-justify mt-5">
      7. Sob pena de responder pelas perdas e danos a que der causa, o(a)
      <b>PARTICIPANTE</b> tem o dever de manter confidencialidade e sigilo de
      todas as informações relacionadas à sua participação na OBRA, sejam de
      natureza técnica ou comercial, ou ainda relacionadas aos demais
      participantes, provas, desenvolvimento e produção da OBRA.
    </p>
    <p class="text-justify mt-5">
      8. O (a) <b>PARTICIPANTE</b> autoriza, declara, consente e concorda,
      ainda, que a Cessionária
      <b>TVSBT Canal 4 de São Paulo S/A, CNPJ nº 45.039.237/0001-14</b>, tome
      decisões e realize o tratamento de meus dados pessoais informados neste
      Termo, com objetivo de participar da OBRA e receber informações e
      promoções do SBT, das demais empresas do Grupo Silvio Santos e de seus
      parceiros comerciais. Conforme rege a Lei 13.709/2018 e a nossa Política
      de Privacidade (https://www.sbt.com.br/politica-de-privacidade), estando
      ciente que tal autorização exclusivamente referente aos meus dados pode
      ser revogada a qualquer momento pelo <b>PARTICIPANTE</b>, mediante a
      requisição formal através do e-mail dpo@sbt.com.br.”
    </p>
    <p class="text-justify mt-5">
      9.
      <b
        >Pelas autorizações supramencionadas e pela cessão dos direitos
        patrimoniais, recebe o(a) PARTICIPANTE, neste ato, da PRODUTORA a
        quantia líquida de R$ _________________________ dando-lhe a mais ampla,
        rasa, geral e irrevogável quitação para nada mais declarar, seja a que
        título for, com relação aos direitos autorizados pelo declarante à
        PRODUTORA.</b
      >
    </p>
    <div class="mt-5 mb-2">
      E, por ser a expressão fiel da sua vontade, firma o presente instrumento.
      <p class="text-justify containerItem">Local / Data:</p>
      <p class="text-justify containerItem">(Assinatura):</p>
    </div>

    <p class="mt-2">Data - {{ new Date() | formatDateMoment }}</p>
  </div>
</template>

<script>
import * as moment from "moment/moment";

export default {
  name: "fullAgeTerm",
  props: {
    data: {
      type: Object,
      required: false,
    },
  },
  filters: {
    formatDate(value) {
      return value
        ? value.replace(/(\d{4})\-(\d{2})\-(\d{2})/, "$3/$2/$1")
        : value;
    },
    formatMobile: (value) => {
      if (!value) return "";
      return value.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
    },
    formatRG: (value) => {
      if (!value) return "";
      return value.replace(/(\d{2})(\d{3})(\d{3})(\d{1,2})/, "$1.$2.$3-$4");
    },
    formatCPF: (value) => {
      if (!value) return "";
      return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    },
    formatDateMoment: (value) => {
      if (!value) return "";
      return moment(value).format("DD/MM/YYYY HH:mm");
    },
  },
};
</script>

<style lang="scss">
.logo {
  max-width: 80px;
}

.containerItem {
  border: 1px solid;
  height: 50px;
}
</style>
